export default [
  {
    path: "/labor/group-attendance/list",
    name: "labor-group-attendance",
    meta: { title: "班组考勤" },
    component: () =>
      import(
        /* webpackChunkName: "labor-group-attendance" */ "@/views/labor/group-attendance/index.vue"
      ),
  },
];
